import Button from '@mui/material/Button';
import MuiLink from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface Props {
  readonly href: string;
  readonly label: string;
}

// An action of an alert opening a page in a new tab, the screen reloading its data once back.
export const NewTabButton = ({ href, label }: Readonly<Props>) => (
  <Button
    color="inherit"
    component={MuiLink}
    endIcon={<OpenInNewIcon />}
    href={href}
    rel="noopener noreferrer"
    size="small"
    target="_blank"
  >
    {label}
  </Button>
);
